import ServiceTokensApi from '@/api/service-tokens'

const serviceTokens = {
  namespaced: true,
  state: {
    isLoading: false,
  },
  mutations: {
    setLoading(state, loading) {
      state.isLoading = loading
    },
  },
  actions: {
    async mintToken({ commit }, { label, ttlDays } = {}) {
      commit('setLoading', true)
      try {
        const params = {}
        if (label) {
          params.label = label
        }
        if (ttlDays !== undefined && ttlDays !== null && ttlDays !== '') {
          params.ttlDays = ttlDays
        }
        const response = await ServiceTokensApi.mintToken(params)
        return response
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        commit('setLoading', false)
      }
    },
    async revokeAllTokens({ commit }) {
      commit('setLoading', true)
      try {
        const response = await ServiceTokensApi.revokeAllTokens()
        return response
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        commit('setLoading', false)
      }
    },
  },
}

export default serviceTokens
